import { axiosAjax } from '@app/src/config/axios';
import { hydrateData, hydrateDataPost, hydrateDataPut } from './hydrators';
import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';

export const rucService = {
  async get(documentNumber: number): Promise<TypeProfileModel> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_TYPE_PROFILE
        .replace(':documentNumber', '' + documentNumber)
        );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  },
  async post(json: TypeProfileModel): Promise<TypeProfileModel> {
    try {
      const { data } = await axiosAjax.post(
        process.env.API_TYPE_PROFILE.replace('/:documentNumber', ''),
        hydrateDataPost(json)
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  },
  async put(json: TypeProfileModel, documentNumber: number): Promise<TypeProfileModel> {
    try {
      const { data } = await axiosAjax.put(
        process.env.API_TYPE_PROFILE
        .replace(':documentNumber', '' + documentNumber),
        hydrateDataPut(json)
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};
    } catch (e) {
      throw new Error(e);
    }
  }
}
